// ACCIONES Inicio
export const SET_MOVIE_DATA = "SET_MOVIE_DATA";
export const CHANGE_PAGE = "CHANGE_PAGE";
export const CHANGE_PAGE_SUCCESS = "CHANGE_PAGE_SUCCESS";
export const FETCH_NEW_MOVIES = "FETCH_NEW_MOVIES";

// ACCIONES Layout
export const SEARCH_MOVIE_START = "SEARCH_MOVIE_START";
export const SEARCH_MOVIE_SUCCESS = "SEARCH_MOVIE_SUCCESS";
export const RESTART_SEARCH_VALUES = "RESTART_SEARCH_VALUES";

// ACCIONES InfoPelicula
export const FETCH_INFO_INIT = "FETCH_INFO_INIT";
export const FETCH_INFO_SUCCESS = "FETCH_INFO_SUCCESS";

// ACCIONES MovieReviews
export const REQUEST_REVIEW_INIT = "REQUEST_REVIEW_INIT";
export const REQUEST_REVIEW_SUCCESS = "REQUEST_REVIEW_SUCCESS";
export const REQUEST_REVIEW_ERROR = "REQUEST_REVIEW_ERROR";
export const CLOSE_ALERT = "CLOSE_ALERT";
export const CHANGE_REVIEW_STATUS = "CHANGE_REVIEW_STATUS";

// ACCIONES Auth
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const SET_AUTH_REDIRECT_PATH = "SET_AUTH_REDIRECT_PATH";
export const UPDATE_USER_IMAGE = "UPDATE_USER_IMAGE";
export const SAVE_MOVIE_INIT = "SAVE_MOVIE_INIT";
export const SAVE_MOVIE_SUCCESS = "SAVE_MOVIE_SUCCESS";
export const SAVE_MOVIE_ERROR = "SAVE_MOVIE_ERROR";

// ACCIONES Reviews
export const FETCH_REVIEWS_INIT = "FETCH_REVIEWS_INIT";
export const FETCH_REVIEWS_SUCCESS = "FETCH_REVIEWS_SUCCESS";
export const FETCH_REVIEWS_ERROR = "FETCH_REVIEWS_ERROR";
export const LIKE_REVIEW_SUCCESS = "LIKE_REVIEW_SUCCESS";

// ACCIONES User
export const FETCH_USER_INIT = "FETCH_USER_INIT";
export const FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS";
export const FETCH_USER_ERROR = "FETCH_USER_ERROR";